import { LDReactClient } from "@launchdarkly/react-sdk";

const noop = () => undefined;
const unsubscribe = () => noop;

/**
 * A stand-in for the LaunchDarkly client when flags can't be used (no client-side ID, or the SDK
 * can't create its client — e.g. site storage blocked). It never becomes ready, so every flag hook
 * returns its default, and it contains no SDK code, so it can't throw or reach the network.
 * Implements what the SDK's provider and variation hooks call; nothing else is supported.
 */
export const createDisabledFeatureFlagClient = (): LDReactClient =>
  ({
    isReady: () => false,
    getContext: noop,
    getInitializationState: () => "initializing",
    getInitializationError: noop,
    onInitializationStatusChange: unsubscribe,
    onContextChange: unsubscribe,
    on: noop,
    off: noop,
    allFlags: () => ({}),
  }) as unknown as LDReactClient;
